module.exports = __webpack_public_path__ + "fonts/Arialnbi.ae954021.ttf";